import API from "./axios";

export const postTicket = async (payload) => {
  try {
    const response = await API.post("support/create-ticket", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      success: true,
      message: response.data?.message || "Your Ticket has been sent!",
    };
  } catch (error) {
    let errorMessage = "An unexpected error occurred. Please try again.";

    if (error.response) {
      errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Failed to send request.";
    } else if (error.request) {
      errorMessage =
        "No response from the server. Please check your internet connection.";
    }

    return { success: false, message: errorMessage };
  }
};